import {
  keepPreviousData,
  useInfiniteQuery,
  useQueryClient,
} from "@tanstack/react-query"
import { getAlbaranByFilter } from "api/Albaran.service"
import { getPedidosByFilter } from "api/Pedido.service"
import { getPresupuestoByFilter } from "api/Presupuesto.service"
import { AlbaranReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/AlbaranReadingFiltersDtoIPagedEnumerable"
import { FacturaReadingFiltersDtoIPagedEnumerableProps } from "api/Schemas/FacturaReadingFiltersDtoIPagedEnumerable"
import { PedidoReadingFiltersDtoIPagedEnumerable } from "api/Schemas/PedidoReadingFiltersDtoIPagedEnumerable"
import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"

export function useAsociarDocumentos({
  values,
  serieNumero,
  optionDateFilter,
  optionCurrentFilter,
  librado,
  librador,
  isVenta,
}: {
  values?: $TSMigrationFixMe
  serieNumero?: $TSMigrationFixMe
  optionDateFilter?: $TSMigrationFixMe
  optionCurrentFilter?: $TSMigrationFixMe
  librado?: $TSMigrationFixMe
  librador?: $TSMigrationFixMe
  isVenta: boolean
}) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: [
        "getAsociarDocumentos",
        values.selectDocument,
        serieNumero,
        optionDateFilter,
        optionCurrentFilter,
        librado,
        librador,
        isVenta,
      ],
      queryFn: ({ pageParam }) => {
        const filters: $TSMigrationFixMe = {
          LibradoId: librado,
          LibradorId: librador,
          SkipCount: pageParam,
          maxResultCount: 10,
          sortingCriteria: "fechaEmision DESC",
        }
        if (serieNumero) {
          filters.SerieNumero = serieNumero
        }
        if (
          optionDateFilter &&
          Array.isArray(optionDateFilter) &&
          optionDateFilter.length >= 2
        ) {
          const [lowerLimit, upperLimit] = optionDateFilter // Utiliza array destructuring para extraer los límites de fecha

          filters.FechaEmisionLowerLimit =
            lowerLimit instanceof Date ? lowerLimit : undefined
          filters.FechaEmisionUpperLimit =
            upperLimit instanceof Date ? upperLimit : undefined
        }
        if (optionCurrentFilter.ImporteLowerLimit !== null) {
          filters.ImporteLowerLimit = optionCurrentFilter.ImporteLowerLimit
        }

        if (optionCurrentFilter.ImporteUpperLimit !== null) {
          filters.ImporteUpperLimit = optionCurrentFilter.ImporteUpperLimit
        }
        if (values.selectDocument === TYPES_DOCUMENTOS.PEDIDO) {
          return getPedidosByFilter(filters)
        }
        if (values.selectDocument === TYPES_DOCUMENTOS.ALBARAN) {
          return getAlbaranByFilter(filters)
        }
        return getPresupuestoByFilter(filters)
      },

      getNextPageParam: (
        lastPage:
          | PedidoReadingFiltersDtoIPagedEnumerable
          | AlbaranReadingFiltersDtoIPagedEnumerableProps
          | FacturaReadingFiltersDtoIPagedEnumerableProps
      ) =>
        lastPage?.currentPage &&
        lastPage.totalCount &&
        lastPage.currentPage * 20 < lastPage.totalCount
          ? lastPage?.currentPage * 20
          : undefined,
      initialPageParam: 0,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      retry: false,
    })

  return {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}

export function useAsociarDocumentosInvalidation() {
  const queryClient = useQueryClient()

  const deleteInfiniteQueryAsociarDoc = () => {
    queryClient.invalidateQueries({ queryKey: ["getAsociarDocumentos"] })
  }

  return { deleteInfiniteQueryAsociarDoc }
}
